function parseCountDownSeconds(timeToOpen) {
    if (!timeToOpen || typeof timeToOpen !== 'string') {
        return null;
    }
    const parts = timeToOpen.split(':');
    if (parts.length < 3) {
        return null;
    }
    const seconds = parseInt(parts[0], 10) * 3600
        + parseInt(parts[1], 10) * 60
        + parseInt(parts[2], 10);
    return Number.isFinite(seconds) ? seconds : null;
}

export function buildAnketaFinishedPayload({ user, subscribed, preview }) {
    const payload = {
        clientHash: user?.hash ?? '',
        clientName: user?.name ?? '',
        subscribed: !!subscribed,
    };

    if (preview?.time_to_open) {
        payload.timeToOpen = preview.time_to_open;
        const countDownSeconds = parseCountDownSeconds(preview.time_to_open);
        if (countDownSeconds != null) {
            payload.countDownSeconds = countDownSeconds;
        }
    }

    return payload;
}

export function emitAnketaFinishedCallback(appEvent, options) {
    const { isReedit, ...payloadOptions } = options;
    const data = buildAnketaFinishedPayload(payloadOptions);
    const eventName = isReedit ? 'onAnketaIsUpdated' : 'onAnketaIsFinished';
    appEvent(eventName, data);
}
